import { action, extendObservable } from 'mobx';
import { browserHistory } from 'react-router';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired } from '../../../core/validations';

export default class PlacementTestFormService {
  fetch = new FetchService();
  submit = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      placementTestId: null,
    });
    this.form.validations = {
      placementTestLevel: [isRequired],
      // placementTestRuler: [isRequired],
      order: [isRequired],
      grammar: [isRequired],
    };
  }

  handleLoad = action((placementTestId, rulerId) => {
    this.form.reset();
    if (placementTestId) {
      this.fetch
        .fetch({
          url: `/grammar-placement-test-levels/${placementTestId}`,
          apiVersion: 'v3',
        })
        .then(() => {
          if (this.fetch.data) {
            this.form.setInitialValues({
              ...this.fetch.data,
              ...(!this.fetch.data.placementTestRuler && {
                placementTestRuler: 'default',
              }),
            });
          }
        });
    } else {
      this.form.setInitialValues({ placementTestRuler: rulerId });
    }
    this.form.validations.placementTestRuler = [isRequired];
    this.placementTestId = placementTestId;
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }
    const placementTestId = this.form.getValue('id');
    const formValues = { ...this.form.getValues() };
    if (formValues.placementTestRuler === 'default') {
      delete formValues.placementTestRuler;
    }
    this.submit
      .fetch({
        method: placementTestId ? 'put' : 'post',
        url: placementTestId ? `/grammar-placement-test-levels/${placementTestId}` : '/grammar-placement-test-levels',
        body: {
          ...formValues,
        },
        apiVersion: 'v3',
      })
      .then(() => {
        if (this.submit.data) {
          const placementTest = this.submit.data;
          browserHistory.push(`/placement-test/${placementTest.id}`);
          this.placementTestId = placementTest.id;
          this.form.reset();
          this.form.setInitialValues(placementTest);
          NotificationService.addNotification(
            `Placement Test Grammar ${placementTestId ? 'updated' : 'created'} successfully.`,
            'success'
          );
        }
        if (this.submit.error) {
          NotificationService.addNotification(
            `Error ${placementTestId ? 'updating' : 'creating'} Placement Test Grammar.`,
            'error'
          );
        }
      });
  });
}
